export default (text: string): string => {
  const el = document.createElement("span")
  el.innerHTML = text
  return el.textContent || el.innerText || ""
}
